import service, { serviceOpenAPI } from "Utility/Service";
import { useQuery, useQueryClient, useMutation } from "react-query";
import { AxiosRequestConfig } from "axios";
import { EventList } from "Utility/Types/alarm_event_notification";
import { InfoList } from "Utility/Types/management";

const getInfByCid = async (level: any, stateCid: any, loginCid: any) => {
  let body: any = { list_inf: {} };

  if (level === "super_super" && stateCid !== "") {
    body.list_inf.cid = stateCid;
  } else if (level !== "super_super") {
    body.list_inf.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/inf_mgnt",
    data: body,
  };

  const { data } = await service(config);
  return data;
};

export const useCustomerInf = (level: string, stateCid: string, loginCid: string) => {
  return useQuery(["customerInf", stateCid], () => getInfByCid(level, stateCid, loginCid));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const listCustomerInf = async (): Promise<InfoList> => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/inf_mgnt",
    data: { list_inf: {} },
  };

  const { data } = await service(config);
  return data;
};

export const useListCustomerInf = (level: string, stateCid: string, isLogin: boolean) => {
  return useQuery(["customerInfList", stateCid, isLogin], () => listCustomerInf(), {
    enabled: level === "super_super" && isLogin,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createCustomerInf = async (props: any) => {
  const { values } = props;

  const token_config: AxiosRequestConfig = {
    method: "post",
    url: "/user_mgnt",
    data: { generate_token: {} },
  };

  let UserToken = await service(token_config).then((res: any) => res.data.response.token);

  // const createInf_config: AxiosRequestConfig = {
  //   method: "post",
  //   url: "api/customerinfo/",
  //   data: {
  //     company: values.company || "",
  //     contact: values.contact || "",
  //     mail: values.mail || "",
  //     phone: values.phone || "",
  //   },
  // };
  const createInf_config: AxiosRequestConfig = {
    method: "post",
    url: "/inf_mgnt",
    data: {
      create_inf: {
        cid: UserToken,
        inf_list: {
          company: values.company || "",
          contact: values.contact || "",
          mail: values.mail || "",
          phone: values.phone || "",
        },
      },
    },
  };

  await service(createInf_config);

  const createScheme_config: AxiosRequestConfig = {
    method: "post",
    url: "/scheme_mgnt",
    data: {
      create_scheme: {
        cid: UserToken,
        scheme_list: {
          user: values.user || 10,
          group: values.group || 50,
          device: values.device || 1000,
          expire: Date.parse(values.expire || 2030 - 12 - 12) / 1000,
          tracking: 123,
          tracking_pool: 123,
          iot: 123,
          iot_poor: 123,
          period_alive: values.period_alive,
          alive_timeout: values.period_alive + 30,
          period_status: values.period_status,
          period_gps: values.period_gps,
          period_iot: values.period_iot,
          permission_viewFlowData: values.permission_viewFlowData,
        },
      },
    },
  };

  await service(createScheme_config);

  const createPeriod_config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        device_cfg: {
          filter: { cid: UserToken },
          obj: {
            report_period: {
              alive: values.period_alive,
              timeout: values.period_alive + 30,
              status: values.period_status,
              iot: values.period_iot,
              gps: values.period_gps,
              permission_viewFlowData: values.permission_viewFlowData,
            },
          },
        },
      },
    },
  };

  return service(createPeriod_config);
};

export const useCreateCustomerInf = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createCustomerInf(props), {
    onSuccess: () => {
      queryClient.invalidateQueries(["customerInf"]);
      queryClient.invalidateQueries(["customerInfList"]);
    },
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const editCustomerInf = (props: any) => {
  const { values, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/inf_mgnt",
    data: {
      modify_inf: {
        cid: cid, //record.cid
        inf_list: {
          company: values.company,
          contact: values.contact,
          mail: values.mail,
          phone: values.phone,
        },
      },
    },
  };

  return service(config);
};

export const useEditCustomerInf = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => editCustomerInf(props), {
    onSuccess: () => {
      queryClient.invalidateQueries(["customerInf"]);
      queryClient.invalidateQueries(["customerInfList"]);
    },
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteCustomerInf = (props: any) => {
  const { cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/inf_mgnt",
    data: { delete_inf: { cid: cid } }, //record.cid
  };

  return service(config);
};

export const useDeleteCustomerInf = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteCustomerInf(props), {
    onSuccess: () => {
      queryClient.invalidateQueries(["customerInf"]);
      queryClient.invalidateQueries(["customerInfList"]);
    },
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getEventLog = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: { get: { event_log: { filter: { cid: cid } } } }, //record.cid
  };

  const { data }: { data: EventList } = await service(config);

  return data.response.event_log.list[0].event_list;
};

export const useEventLog = (cid: string | undefined, eventLogModalvisible: boolean) => {
  return useQuery(["customerEventLog"], () => getEventLog(cid), { enabled: eventLogModalvisible && !!cid });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createGroup = (props: any) => {
  const { values, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/group",
    data: {
      create_group: {
        cid: cid, //record.cid
        group_list: [{ name: values.groupName, node_list: values.Device_ID }],
      },
    },
  };

  return service(config);
};

export const useCreateGroup = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createGroup(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceGroup"]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getNodeInf = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/cmd",
    data: {
      get: {
        nodeInf: {
          filter: { cid: cid },
          nodeInf: { city: {}, id: {}, name: {} },
        },
      },
    },
  };

  const { data } = await service(config);
  let NodeList: any[] = [];
  let locationList: any = new Set();
  data.response.nodeInf.map((item: any, index: number) => {
    if (item.nodeInf?.city) {
      locationList.add(item.nodeInf.city);
    }
    NodeList.push({
      key: index,
      id: item.nodeInf.id,
      name: item.nodeInf.name,
      name_or_id: item.nodeInf.name !== "" ? item.nodeInf.name : item.nodeInf.id,
      city: item.nodeInf.city,
    });
  });
  locationList = Array.from(locationList);
  return { NodeList, locationList };
};

export const useNodeInf = (cid: string | undefined, GroupModalvisible: boolean) => {
  return useQuery(["devicesNodeInf", cid], () => getNodeInf(cid), { enabled: !!cid && GroupModalvisible });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getDeviceGroupByCid = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/group",
    data: { list_group: { cid: cid } }, //record.cid
  };

  const { data } = await service(config);
  let tableData = data.response[0].group_list.map((item: any, index: number) => {
    return {
      key: index,
      name: item.gid,
      node_list_name_id: item.node_list, // {id: "014BBL7VB3WE0000", name: "這是一台機器"}
      node_list: item.node_list.map((item: any) => item.id), // [id1, id2]
    };
  });
  return { tableData, group_list: data.response[0].group_list };
};

export const useDeviceGroup = (cid: string | undefined, GroupModalvisible: boolean) => {
  return useQuery(["deviceGroup"], () => getDeviceGroupByCid(cid), { enabled: !!cid && GroupModalvisible });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateGroup = (props: any) => {
  const { values, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/group",
    data: { modify_group: { cid: cid, group_list: values.Group } }, //record.cid
  };

  return service(config);
};

export const useUpdateGroup = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateGroup(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceGroup"]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteGroup = (props: any) => {
  const { name, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/device_mgnt/group",
    data: {
      delete_group: {
        cid: cid, //record.cid
        group_list: [{ name: name }], //grouprecord.name
      },
    },
  };

  return service(config);
};

export const useDeleteGroup = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteGroup(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceGroup"]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getNotificationByCid = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: { get: { notification: { filter: { cid: cid } } } }, //record.cid
  };

  const { data } = await service(config);
  return data.response.notification[0];
};

export const useCustomerNotification = (cid: string | undefined, NotifiModalvisible: boolean) => {
  return useQuery(["notification"], () => getNotificationByCid(cid), { enabled: !!cid && NotifiModalvisible });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const testNotification = (props: any) => {
  const { values } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        notification_test: {
          mail_test: values.mail_active,
          // mail_server: values.mail_server,
          // mail_port: values.mail_port,
          // mail_from: values.mail_from,
          // mail_token: values.mail_token,
          mail_to: values.mail_to,
          line_test: values.line_active,
          line_token: values.line_token,
          mqtt_test: "disable",
          // mqtt_ip: values.mqtt_ip,
          // mqtt_port: values.mqtt_port,
          // mqtt_topic: values.mqtt_topic || "",
          // mqtt_secure: values.mqtt_secure || "none",
          // mqtt_user: values.mqtt_user || "",
          // mqtt_pwd: values.mqtt_pwd || "",
         
          telegram_test: values.telegram_active ?? false,
          telegram_token:values.telegram_token,
          telegram_chat_id:values.telegram_chat_id,
          discord_test:values.discord_active ?? false,
          discord_url:values.discord_url,
          slack_test: values.slack_active ?? false,
          slack_token:values.slack_token,
          slack_channel_id:values.slack_channel_id,
          ntfy_test: values.ntfy_active ?? false,
          ntfy_topic:values.ntfy_topic,
          chatwork_test: values.chatwork_active ?? false,
          chatwork_token: values.chatwork_token,
          chatwork_room_id: values.chatwork_room_id,
          team_plus_test: values.teamPlus_active ?? false,
          team_plus_token:values.teamPlus_token,
          team_plus_url:values.teamPlus_url,
          team_plus_app_name: values.teamPlus_appName,
      
        },
      },
    },
  };

  return service(config);
};

export const useTestNotification = () => {
  // const queryClient = useQueryClient();
  return useMutation((props: any) => testNotification(props));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateNotification = (props: any) => {
  const { values, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        notification: [
          {
            cid: cid, //record.cid
            timezone: values.timezone || "Asia / Taipei",
            conditions: { level: values.level || "INFO" },
            mail: {
              active: values.mail_active ?? false,
              // mail_server: values.mail_server,
              // mail_port: values.mail_port,
              mail_from: values.mail_from,
              mail_to: values.mail_to,
              // token: values.mail_token,
            },
            line: { 
              active: values.line_active ?? false, 
              token: values.line_token ?? ""
            },
            mqtt: {
              active: "disable",
              // ip: values.mqtt_ip || "",
              // port: values.mqtt_port || 0,
              // topic: values.mqtt_topic || "",
              // secure: values.mqtt_secure || "none",
              // user: values.mqtt_user || "",
              // pwd: values.mqtt_pwd || "",
            },
            chatwork: {
              active: values.chatwork_active ?? false,
              token: values.chatwork_token ?? "",
              room_id: values.chatwork_room_id ?? "",
            },
            telegram:{
              active:values.telegram_active ?? false,
              chat_id:values.telegram_chat_id ?? "",
              token:values.telegram_token ?? ""
            },
            discord:{
              active:values.discord_active ?? false,
              url:values.discord_url ?? ""
            },
            ntfy:{
              active:values.ntfy_active ?? false,
              topic:values.ntfy_topic ?? "",
            },
            slack:{
              active:values.slack_active ?? false,
              channel_id:values.slack_channel_id ?? "",
              token:values.slack_token ?? ""
            },
            team_plus:{
              active:values.teamPlus_active ?? false,
              token:values.teamPlus_token ?? "",
              url:values.teamPlus_url ?? "",
              app_name:values.teamPlus_appName ?? ""
            }

          },
        ],
      },
    },
  };

  return service(config);
};

export const useUpdateNotification = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateNotification(props), {
    onSuccess: () => queryClient.invalidateQueries(["notification", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getSchemeByCid = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/scheme_mgnt",
    data: { list_scheme: { cid: cid } }, //record.cid
  };

  const { data } = await service(config);
  let SchemeData = data.response[0].scheme_list;

  let expire = new Date(SchemeData.expire * 1000);
  SchemeData.expire = `${expire.getFullYear()}-${expire.getMonth() + 1}-${expire.getDate()}`;

  let expires = new Date(SchemeData.expires * 1000);
  SchemeData.expires = `${expires.getFullYear()}-${expires.getMonth() + 1}-${expires.getDate()}`;

  return SchemeData;
};

export const useSchemeByCid = (cid: string | undefined, SchemeModalvisible: boolean) => {
  return useQuery(["scheme", cid], () => getSchemeByCid(cid), {
    enabled: !!cid && SchemeModalvisible,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getSchemeList = async (stateCid: string, loginCid: string, level: string) => {
  let body: any = { list_scheme: {} };

  if (level === "super_super" && stateCid !== "") {
    body.list_scheme.cid = stateCid;
  } else if (level !== "super_super") {
    body.list_scheme.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/scheme_mgnt",
    data: body,
  };

  const { data } = await service(config);

  return data.response?.[0]?.scheme_list;
};

export const useGetSchemeList = (stateCid: string, loginCid: string, level: string, isLogin: boolean) => {
  return useQuery(["schemeList", stateCid, isLogin], () => getSchemeList(stateCid, loginCid, level), {
    enabled: isLogin && level !== "set" && level !== "get",
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const update_or_create_Scheme = async (props: any) => {
  const { values, cid, IsCreate } = props;

  let body: any = {};

  let Schemedata = {
    cid: cid, //record.cid
    scheme_list: {
      user: values.user || 10,
      group: values.group || 50,
      device: values.device || 1000,
      expire: Date.parse(values.expire || "2030-12-31") / 1000,
      tracking: 123,
      tracking_pool: 123,
      iot: 123,
      iot_poor: 123,
      period_alive: values.period_alive,
      alive_timeout: values.period_alive + 30,
      period_status: values.period_status,
      period_gps: values.period_gps,
      period_iot: values.period_iot,
      permission_viewFlowData: values.permission_viewFlowData,
    },
  };

  if (IsCreate) {
    body.create_scheme = Schemedata;
  } else {
    body.modify_scheme = Schemedata;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/scheme_mgnt",
    data: body,
  };

  const period_config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        device_cfg: {
          filter: { cid: cid }, //record.cid
          obj: {
            report_period: {
              alive: values.period_alive,
              timeout: values.period_alive + 30,
              status: values.period_status,
              iot: values.period_iot,
              gps: values.period_gps,
            },
          },
        },
      },
    },
  };

  await service(period_config);

  return service(config);
};

export const useUpdateOrCreateScheme = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => update_or_create_Scheme(props), {
    onSuccess: () => queryClient.invalidateQueries(["scheme", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getTokenByCid = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: { list_token: { cid: cid } },
  };

  const { data } = await service(config);

  return data.response[0];
};

export const useDeviceToken = (cid: string | undefined, Tokenvisible: boolean) => {
  return useQuery(["deviceToken", cid], () => getTokenByCid(cid), {
    enabled: !!cid && Tokenvisible,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateToken = async (props: any) => {
  const { cid, token_list } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: {
      modify_token: {
        cid: cid, // record.cid
        token_list: token_list,
      },
    },
  };

  return service(config);
};

export const useUpdateToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateToken(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createToken = async (props: any) => {
  const { cid } = props;

  const generateToken_config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: { generate_token: {} },
  };
  let newToken = await service(generateToken_config).then((res) => {
    return res.data.response.token;
  });
  const createToken_config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: { create_token: { cid: cid, token_list: [newToken] } }, //record.cid,
  };

  return service(createToken_config);
};

export const useCreateToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createToken(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteToken = async (props: any) => {
  const { cid, item } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: { delete_token: { cid: cid, token_list: [item] } }, // record.cid
  };

  return service(config);
};

export const useDeleteToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteToken(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const enableToken = async (props: any) => {
  const { cid, enable } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token",
    data: { modify_token: { cid: cid, active: enable } },
  };

  return service(config);
};

export const useEnableToken = (cid?: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => enableToken(props), {
    onSuccess: () => queryClient.invalidateQueries(["deviceToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getUserByCid = async (cid: string | undefined, level: string) => {
  //   const config: AxiosRequestConfig = {
  //     method: "get",
  //     url: `api/user/?cid=${cid}`,
  //   };

  //   let { data } = await service(config);

  //   if (level === "admin") {
  //     data = data.filter((item: any) => item.level !== "super");
  //   }

  //   return data;
  // };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/user_mgnt",
    data: { list_user: { cid: cid } }, //record.cid
  };

  const { data } = await service(config);

  let UserList: any = [];
  if (data.response?.[0]?.user_list) {
    data.response[0].user_list.forEach((item: any, index: number) => {
      if (level === "admin" && item.level === "super") {
        return;
      }
      UserList.push({
        key: index,
        name: item.name,
        level: item.level,
        gid: item.gid,
      });
    });
  }
  return UserList;
};

export const useUser = (cid: string | undefined, level: string, CreateUservisible: boolean) => {
  return useQuery(["user", cid], () => getUserByCid(cid, level), {
    enabled: !!cid && CreateUservisible,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createUser = async (props: any) => {
  const { cid, values } = props;

  values.users.map((user: any) => {
    user.cid = cid;
    user._id = user.name;
  });

  // const config: AxiosRequestConfig = {
  //   method: "post",
  //   url: "/api/user/",
  //   data: values.users,
  // };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/user_mgnt",
    data: { create_user: { cid: cid, user_list: values.users } }, //record.cid
  };

  return service(config);
};

export const useCreateUser = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createUser(props), {
    onSuccess: () => queryClient.invalidateQueries(["user", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateUser = async (props: any) => {
  const { cid, values } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/user_mgnt",
    data: { modify_user: { cid: cid, user_list: values.EditUser } },
  };

  return service(config);
};

export const useUpdateUser = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateUser(props), {
    onSuccess: () => queryClient.invalidateQueries(["user", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// const deleteUser = async (props: any) => {
//   const { cid, name } = props;

//   const config: AxiosRequestConfig = {
//     method: "post",
//     url: "/user_mgnt",
//     data: {
//       delete_user: {
//         cid: cid, //record.cid
//         user_list: [{ name: name }], //Deleterecord.name
//       },
//     },
//   };

//   return service(config);
// };

// export const useDeleteUser = (cid: string | undefined) => {
//   const queryClient = useQueryClient();
//   return useMutation((props: any) => deleteUser(props), {
//     onSuccess: () => queryClient.invalidateQueries(["user", cid]),
//   });
// };

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteUser = async (props: any) => {
  // const { name } = props;

  // const config: AxiosRequestConfig = {
  //   method: "delete",
  //   url: `api/user/${name}/`,
  // };

  const { cid, name } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/user_mgnt",
    data: {
      delete_user: {
        cid: cid, //record.cid
        user_list: [{ name: name }], //Deleterecord.name
      },
    },
  };

  return service(config);
};

export const useDeleteUser = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteUser(props), {
    onSuccess: () => queryClient.invalidateQueries(["user", cid]),
  });
};

//////updateOpenapiToken////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateOpenapiToken = async (cid: string | undefined) => {
  try {
    await serviceOpenAPI.post(`/router/managemt/openapi_token`, { cid }); // 傳 JSON body
  } catch (error: any) {
    console.error("Error updating OpenAPI Token:", error);
    throw error;
  }
};

export const useUpdateOpenapiToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation(() => updateOpenapiToken(cid), {
    onSuccess: () => queryClient.invalidateQueries(cid ==="osmart"?["setting"]:["openapiToken", cid]),
  });
};


/////////token_openapi///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getOpenapiTokenByCid = async (cid: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token_openapi",
    data: { list_token: { cid: cid } },
  };

  const { data } = await service(config);

  return data.response[0];
};

export const useOpenapiToken = (cid: string | undefined, Tokenvisible: boolean) => {
  return useQuery(["openapiToken", cid], () => getOpenapiTokenByCid(cid), {
    enabled: !!cid && Tokenvisible,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const modifyOpenapiToken = async (props: any) => {
  const { cid, openapi_token } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token_openapi",
    data: {
      modify_token: {
        cid: cid, // record.cid
        openapi_token: openapi_token
      },
    },
  };

  return service(config);
};

export const useModifyOpenapiToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => modifyOpenapiToken(props), {
    onSuccess: () => queryClient.invalidateQueries(cid ==="osmart"?["setting"]:["openapiToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const createOpenapiToken = async (props: any) => {
  const { cid } = props;

  const generateToken_config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token_openapi",
    data: { generate_token: {cid:cid} },
  };
  let newToken = await service(generateToken_config).then((res) => {
    return res?.data?.response?.openapi_token;
  });
  const createToken_config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token_openapi",
    data: { create_token: { cid: cid, token_list: [newToken] } }, //record.cid,
  };

  return service(createToken_config);
};

export const useCreateOpenapiToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => createOpenapiToken(props), {
    onSuccess: () => queryClient.invalidateQueries(cid ==="osmart"?["setting"]:["openapiToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteOpenapiToken = async (props: any) => {
  const { cid, item } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/token_openapi",
    data: { delete_token: { cid: cid, token_list: [item] } }, // record.cid
  };

  return service(config);
};

export const useDeleteOpenapiToken = (cid: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteOpenapiToken(props), {
    onSuccess: () => queryClient.invalidateQueries(["openapiToken", cid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
